import { Controller } from "@hotwired/stimulus"

const HEADER_PATTERN = /^([A-Z][A-Z ]+):\s*$/

export default class extends Controller {
  static targets = [ "textarea", "list" ]

  declare textareaTarget: HTMLTextAreaElement
  declare listTarget: HTMLElement

  connect(): void {
    this.scan()
  }

  scan(): void {
    const lines = this.textareaTarget.value.split("\n")
    const headers: Array<{ text: string; lineIndex: number }> = []

    lines.forEach((line, i) => {
      const match = line.match(HEADER_PATTERN)
      if (match) headers.push({ text: match[1], lineIndex: i })
    })

    this.listTarget.innerHTML = ""
    if (headers.length === 0) {
      const li = document.createElement("li")
      li.className = "opacity-40 italic px-2"
      li.textContent = "none yet"
      this.listTarget.appendChild(li)
      return
    }

    headers.forEach(({ text, lineIndex }) => {
      const li = document.createElement("li")
      const btn = document.createElement("button")
      btn.type = "button"
      btn.className = "badge badge-sm badge-ghost hover:badge-primary cursor-pointer"
      btn.textContent = text
      btn.addEventListener("click", () => this.jumpTo(lineIndex))
      li.appendChild(btn)
      this.listTarget.appendChild(li)
    })
  }

  private jumpTo(lineIndex: number): void {
    const ta = this.textareaTarget
    const lines = ta.value.split("\n")
    const charOffset = lines.slice(0, lineIndex).reduce((sum, line) => sum + line.length + 1, 0)
    ta.focus()
    ta.setSelectionRange(charOffset, charOffset + (lines[lineIndex]?.length ?? 0))

    const totalChars = ta.value.length
    if (totalChars > 0) {
      ta.scrollTop = (charOffset / totalChars) * (ta.scrollHeight - ta.clientHeight)
    }
  }
}
